import { RequestBasePage, ResponseBase, ResponseBasePage } from "src/app/modules/fwcore/models";
import {
  RateDashConfidence, RateDashCountry, RateDashCurrency, RateDashFilterOption, RateDashKpi,
  RateDashRateCard, RateDashRole, RateDashRow, RateDashYoe, RateDashYoeRange
} from "src/app/features/prob/models";

/**
 * The filters every IT Labor Rate Dashboard call takes. Lists go out as countries[0]=...,
 * which ASP.NET binds to a list; the API pipe-joins them for the procedures. An empty or
 * missing list means "not filtered".
 */
export class RequestRateDashFilter extends RequestBasePage {
  rateId?: string | null;
  tierType?: string | null;
  countries?: string[] | null;
  regions?: string[] | null;
  roles?: string[] | null;
  skillSets?: string[] | null;
  staffLocations?: string[] | null;
  consultancyTypes?: string[] | null;
  confidenceLevels?: string[] | null;
  yoeMinFrom?: number | null;
  yoeMinTo?: number | null;
  yoeMaxFrom?: number | null;
  yoeMaxTo?: number | null;
}

/**
 * Request the rate cards, currencies and the filter values still available. RateId and
 * TierType are optional: without them every rate card is listed.
 */
export class RequestRateDashFilterOptions extends RequestRateDashFilter {
}

/**
 * Response with the rate cards, display currencies, available filter values and YoE bounds.
 */
export class ResponseRateDashFilterOptions extends ResponseBase {
  rateCards: RateDashRateCard[] = [];
  currencies: RateDashCurrency[] = [];
  options: RateDashFilterOption[] = [];
  yoeRange?: RateDashYoeRange | null;
}

/**
 * Request the aggregates behind the KPIs, map and charts. RateId and TierType are required.
 */
export class RequestRateDashSummary extends RequestRateDashFilter {
  /** Defaults to USD on the server. */
  displayCurrency?: string | null;
}

/**
 * Response with the KPIs and the by-country, by-role, by-YoE and by-confidence aggregates.
 */
export class ResponseRateDashSummary extends ResponseBase {
  kpi?: RateDashKpi | null;
  countries: RateDashCountry[] = [];
  roles: RateDashRole[] = [];
  experience: RateDashYoe[] = [];
  confidence: RateDashConfidence[] = [];
}

/**
 * Request one server-side page of the filtered combinations. RateId and TierType are
 * required; pagesize may not exceed 1,000.
 */
export class RequestRateDashDetail extends RequestRateDashFilter {
  displayCurrency?: string | null;
  /** deliveredFrom, role, consultancyType, yoeMin, yoeMax, skillSet, staffLocation, P10-P90,
   *  confidenceLevel or confidenceScore. Sort the Confidence column by confidenceScore:
   *  confidenceLevel sorts alphabetically. */
  sortBy?: string | null;
  sortDesc?: boolean | null;
}

/**
 * Response with one page of combinations; total counts every page.
 */
export class ResponseRateDashDetail extends ResponseBasePage<RateDashRow> {
  page: number = 1;
  pageSize: number = 100;
}
